import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSModal } from '@repo/design-system/index'
import { useEffect } from 'react'
import 'react-reflex/styles.css'
import { useEventTracking } from '../../../../helpers/gtmHelper'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import { n_common, n_lesson_prep } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'

const PreparationAnswerNotSaved = ({ showSavePopup, setShowSavePopup, count, handleSaveButton }) => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const { sendPageViewEvent } = useEventTracking()

  useEffect(() => {
    if (!router) return
    if (!showSavePopup) return
    sendPageViewEvent({ page_name: 'lesson_prep_edit_warning' })
  }, [router, showSavePopup])

  return (
    <DSModal id="TextOnlySMTwoButtonHorizontalPopup" isOpen={showSavePopup} setIsOpen={setShowSavePopup} size="lg">
      <DSModal.Title>{t(n_lesson_prep.popup_save_title(count))}</DSModal.Title>
      <DSModal.Content>{t(n_lesson_prep.popup_save_info)}</DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal">
        <DSButton
          size={BUTTON_SIZE.MD}
          type={BUTTON_TYPE.OUTLINE}
          customBgColor={COLORS.WHITE}
          onClick={() => setShowSavePopup(false)}
        >
          <DSButton.Label>{t(n_common.btn_close)}</DSButton.Label>
        </DSButton>
        <DSButton
          size={BUTTON_SIZE.MD}
          type={BUTTON_TYPE.SOLID}
          customBorderColor={COLORS.PURPLE600}
          onClick={handleSaveButton}
        >
          <DSButton.Label>{t(n_common.btn_save_full)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export default PreparationAnswerNotSaved
